import { render, staticRenderFns } from "./StandardOverview.vue?vue&type=template&id=0735d004&"
import script from "./StandardOverview.vue?vue&type=script&lang=js&"
export * from "./StandardOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports